module.exports = __webpack_public_path__ + "img/icon-cost.a6fb9718.png";